module.exports = __webpack_public_path__ + "img/owner-right.f11b5aa8.png";